import React, { FC } from "react";
import { Icon, Tooltip } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { SpecialFilterStatBlock } from "../styled";

import { formatNumber } from "../../../utils/formatNumber";

export const SumOfValues: FC<{ sum?: number }> = ({ sum }) => {
  const { t } = useTranslation("table");

  return (
    <Tooltip content={t("sumOfValues")} arrow placement="top" delay={50}>
      {ref => (
        <SpecialFilterStatBlock ref={ref}>
          <Icon kind="sum" disabled />
          {formatNumber(+(sum ?? 0).toFixed(2))}
        </SpecialFilterStatBlock>
      )}
    </Tooltip>
  );
};
